module.exports = __webpack_public_path__ + "img/concrete-hole-decal-13.af473756.png";